import { apiClient } from "@/api/apiClient";

type GetPostingsParams = {
  sort?: string;
  filter?: string;
  [key: string]: any;
};

export async function getPostingsAsync(params: GetPostingsParams = {}) {
  const defaultParams = {
    sort: '["createdAt","DESC"]',
    ...params,
  };

  const response = await apiClient().get(`communications/postings`, {
    params: defaultParams,
  });

  return response && response.data ? response.data : null;
}

export async function getPostingsByEstateIdAsync(estateId: number) {
  return getPostingsAsync({ filter: `{"estateId": ${estateId}}` });
}
